const APPROVED_EVENTS = new Set([
    "telemetry_cta_click",
    "telemetry_analysis_open",
    "telemetry_import_start",
    "telemetry_import_accepted",
    "telemetry_import_complete",
    "telemetry_import_error",
    "paddock_pass_view",
    "pricing_open",
    "begin_checkout",
    "checkout_error",
])

const BOUNDED_VALUES = {
    product: new Set(["iracing", "alfano", "gopro", "paddock_pass", "unknown"]),
    placement: new Set([
        "hero",
        "hero_proof",
        "analysis",
        "proof_reminder",
        "faq",
        "final",
        "importer",
        "subscription_wall",
        "pricing",
        "unknown",
    ]),
    stage: new Set([
        "file_validation",
        "entitlement",
        "processing",
        "lap_selection",
        "line_creation",
        "checkout_session",
        "unknown",
    ]),
    error_code: new Set([
        "invalid_file_type",
        "mobile_file_too_large",
        "processing_failed",
        "validation_failed",
        "line_creation_failed",
        "checkout_failed",
        "unknown",
    ]),
    intent: new Set([
        "iracing_import",
        "alfano_import",
        "gopro_import",
        "manual_line",
        "pricing",
        "unknown",
    ]),
    billing_period: new Set(["monthly", "yearly", "unknown"]),
}

const sanitizeAnalyticsParams = (params = {}) =>
    Object.entries(BOUNDED_VALUES).reduce((safe, [name, allowed]) => {
        if (!Object.prototype.hasOwnProperty.call(params, name)) return safe
        safe[name] = allowed.has(params[name]) ? params[name] : "unknown"
        return safe
    }, {})

const trackEvent = (name, params = {}, target) => {
    if (!APPROVED_EVENTS.has(name)) return false

    const analyticsTarget =
        target || (typeof window !== "undefined" ? window : null)
    if (!analyticsTarget || typeof analyticsTarget.gtag !== "function") {
        return false
    }

    try {
        analyticsTarget.gtag(
            "event",
            name,
            sanitizeAnalyticsParams(params)
        )
        return true
    } catch (error) {
        return false
    }
}

module.exports = {
    APPROVED_EVENTS,
    sanitizeAnalyticsParams,
    trackEvent,
}
